import { DesktopFilterSelectOptionHrefParams } from './DesktopFilterSelectOption.types';
import { QUERY } from '@/constants/common';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';
import { hrefWithSearchParams } from '@/components/Filters/FiltersDrawer.helpers';

export function getDesktopFilterSelectOptionHref({
  clearUrl,
  value,
  baseSearchParams,
  queryString,
  propertyParam,
  queryParam,
}: DesktopFilterSelectOptionHrefParams) {
  const searchParams = new URLSearchParams(baseSearchParams ?? queryString);
  const key =
    baseSearchParams || propertyParam
      ? `p[${propertyParam}]`
      : `${QUERY.q}[${queryParam}]`;

  searchParams.set(QUERY.keywordsSource, KeywordsSource.Typewritten);

  if (value) {
    searchParams.set(key, value);
  } else {
    searchParams.delete(key);
  }

  return hrefWithSearchParams(clearUrl, searchParams);
}
